export { default } from './InfoLink';
